module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av489-a12bab7e3233b9fb2dd635adf5cb2d68.jpg";